import { forwardRef } from "react";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import styles from "../PresentationsList.module.scss";

type ContextMenuProps = {
    anchorEl: HTMLElement;
    onDelete: () => void;
    onEdit: () => void;
};

export const ContextMenu = forwardRef<HTMLDivElement, ContextMenuProps>(
    ({ anchorEl, onDelete, onEdit }, ref) => {
        const rect = anchorEl.getBoundingClientRect();

        return (
            <div
                ref={ref}
                className={styles.contextMenu}
                style={{
                    position: "fixed",
                    top: rect.bottom + 7,
                    right: window.innerWidth - rect.right,
                }}
            >
                <BottomBarItem onClick={onEdit}>Переименовать</BottomBarItem>
                <BottomBarItem onClick={onDelete}>Удалить</BottomBarItem>
            </div>
        );
    },
);
